import { MapStore } from './stores/map-store';
import { StorageAdapter } from './stores/adapters/storage-adapter';

const createStorageService = (useSessionStorage = false) => {
    const storage = useSessionStorage ? sessionStorage : localStorage;
    const store = new MapStore(new StorageAdapter(storage));

    return {
        getItem: (name: string): unknown => store.get(name),
        hasItem: (name: string): boolean => store.has(name),
        getItems: () => store.getAll(),
        deleteItem: (name: string): void => store.delete(name),
        setItem: (name: string, value: unknown) => store.set(name, value)
    };
};

const localStorageService = createStorageService(false);
const sessionStorageService = createStorageService(true);
export const { getItem, hasItem, getItems, deleteItem, setItem } = localStorageService;

export { localStorageService, sessionStorageService };
